import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import LoadingDialog from '../Utils/LoadingDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { ReportsTable } from './ReportsTable';
import { ReportDialog } from './ReportDialog';
import { useLocation } from 'react-router';
import RestAPI from '@aws-amplify/api-rest';
import { toast } from 'react-toastify';
import SelfHelp from '../Utils/SelfHelp';
import { capitalize } from '../Form/Form';


const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get('farm');
    return farm;
}

const Reports = ({ dataFarm, sectorsInfo, accountsData, fields, usuarioInfo }) => {
    const { t, i18n } = useTranslation();
    const [dataLoading, setDataLoading] = useState(false);
    const [farmReports, setFarmReports] = useState([]);
    const [reportDialogState, setReportDialogState] = useState({ visible: false, data: {} });
    const [reFetch, setReFetch] = useState(0);
    const location = useLocation();
    const farmId = getFarm(location);

    useEffect(() => {
        setDataLoading(true);
        const getData = async () => {
            try {
                const endpoint = `/farms/${farmId}/reportes`;
                const response = await RestAPI.get('apiAdminDropControl', endpoint)
                setDataLoading(false)
                setFarmReports(response.data);
            } catch (error) {
                toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            }
            setDataLoading(false);
        }
        getData();
    }, [dataFarm.cuenta_id, farmId, t, reFetch]);

    const selfHelpImg1 = import.meta.glob("../../img/autoayuda/*/autoayuda-reportstable-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-reportstable-1.png`];
    const selfHelpImg2 = import.meta.glob("../../img/autoayuda/*/autoayuda-reportstable-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-reportstable-2.png`];

    const selfHelpBulkImg1 = import.meta.glob("../../img/autoayuda/*/autoayuda-reportsbulk-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-reportsbulk-1.png`];
    const selfHelpBulkImg2 = import.meta.glob("../../img/autoayuda/*/autoayuda-reportsbulk-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-reportsbulk-2.png`];
    const selfHelpBulkImg3 = import.meta.glob("../../img/autoayuda/*/autoayuda-reportsbulk-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-reportsbulk-3.png`];
    const selfHelpBulkImg4 = import.meta.glob("../../img/autoayuda/*/autoayuda-reportsbulk-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-reportsbulk-4.png`];

    const selfHelpAddImg1 = import.meta.glob("../../img/autoayuda/*/autoayuda-reportsadd-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-reportsadd-1.png`];
    const selfHelpAddImg2 = import.meta.glob("../../img/autoayuda/*/autoayuda-reportsadd-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-reportsadd-2.png`];

    const selfHelpParams = {
        definitionName: [
            t("general.name"),
            t("general.type"),
            t("automaticReports.timeRange"),
            capitalize(t("farms.etiqueta.equipos")),
            capitalize(t("farms.etiqueta.sectores")),
            t("farms.farms"),
            t("farms.pozo.reportesEmails"),
            t("automaticReports.frequency")
        ],
        definitionText: [
            t("selfHelp.definitions.reportes.name"),
            t("selfHelp.definitions.reportes.type"),
            t("selfHelp.definitions.reportes.timeRange"),
            t("selfHelp.definitions.reportes.equipos"),
            t("selfHelp.definitions.reportes.sectores"),
            t("selfHelp.definitions.reportes.farms"),
            t("selfHelp.definitions.reportes.reportesEmails"),
            t("selfHelp.definitions.reportes.frequency")
        ]
    };

    return (
        <div className='row-container'>
            <div className='col-xl-12 col-lg-12 col-sm-12'>
                 <div id="cardReportes" className="card">
                    {dataLoading && <LoadingDialog appendTo="self" />}
                    <div className="card-body">
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4'>
                              <SelfHelp 
                                t={t} 
                                lng={i18n.language} 
                                target={"ReportesTable"} 
                                images={[
                                    selfHelpImg1, // simple edit img1
                                    selfHelpImg2, // simple edit img2
                                    [selfHelpBulkImg1,selfHelpBulkImg2,selfHelpBulkImg3,selfHelpBulkImg4], // mass edit imgs
                                    [selfHelpAddImg1,selfHelpAddImg2] // create imgs
                                ]}
                                params={selfHelpParams} 
                              />
                            </div>
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title">
                                <span>{t("farms.etiqueta.reports")}</span>
                                </h5>
                            </div>
                            <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'> 
                                <div id='reportsBulkContainer' />

                                <FontAwesomeIcon className='btnEdit pointer text-dark' size="lg" icon={faPlus}
                                    onClick={() => setReportDialogState({ visible: true, data: {}, setReFetch })}
                                    />  
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        {(Array.isArray(farmReports) && farmReports.length > 0) ?
                            <ReportsTable 
                                reports={farmReports} 
                                setReportDialogState={setReportDialogState} 
                                setFarmReports={setFarmReports} 
                                sectorsInfo={sectorsInfo}
                                fields={fields}
                                setReFetch={setReFetch}
                                usuarioInfo={usuarioInfo}
                            />
                            :
                            <span className='no-data'>{t("forms.noData")}</span>
                        }
                        {
                            reportDialogState?.visible && (
                                <ReportDialog
                                    dialogState={reportDialogState}
                                    setDialogState={setReportDialogState}
                                    dataFarm={dataFarm}
                                    sectorsInfo={sectorsInfo}
                                    accountsData={accountsData}
                                    fields={fields}
                                    usuarioInfo={usuarioInfo}
                                />
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reports;
